import { Plus, Trash2, FileText } from "lucide-react";

function Field({ label, value, onChange, textarea, testid, rows = 3 }) {
  return (
    <label className="block">
      <span className="text-[11px] text-slate-500">{label}</span>
      {textarea ? (
        <textarea data-testid={testid} rows={rows} value={value || ""} onChange={(e) => onChange(e.target.value)}
          className="w-full mt-1 px-3 py-2 rounded-md border border-slate-300 focus:outline-none focus:ring-2 focus:ring-emerald-500 text-sm resize-y" />
      ) : (
        <input data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value)}
          className="w-full mt-1 px-3 py-2 rounded-md border border-slate-300 focus:outline-none focus:ring-2 focus:ring-emerald-500 text-sm" />
      )}
    </label>
  );
}

export default function DocumentTab({ config, onExport }) {
  const ec = config || {};
  const consideraciones = ec.consideraciones || [];

  const setClause = (i, v) => {
    const next = [...consideraciones];
    next[i] = v;
    onExport("consideraciones", next);
  };
  const addClause = () => onExport("consideraciones", [...consideraciones, ""]);
  const removeClause = (i) => onExport("consideraciones", consideraciones.filter((_, j) => j !== i));

  const letters = "abcdefghijklmnopqrstuvwxyz";

  return (
    <div className="space-y-6">
      <div className="bg-slate-100 border border-slate-200 rounded-md px-4 py-2.5 text-xs text-slate-600 flex items-center gap-2">
        <FileText className="h-4 w-4" /> Estos textos aparecen en el PDF/Excel exportado. Usa <b>{"{cliente}"}</b> y <b>{"{proyecto}"}</b> como marcadores automáticos.
      </div>

      <div className="bg-white border border-slate-200 rounded-lg p-5 space-y-4">
        <h3 className="font-display font-bold text-slate-900 text-sm uppercase tracking-wide">Portada</h3>
        <div className="grid sm:grid-cols-2 gap-4">
          <Field label="Atención (nombre de la persona)" testid="export-atencion" value={ec.atencion} onChange={(v) => onExport("atencion", v)} />
          <Field label="Servicio" testid="export-servicio" value={ec.servicio} onChange={(v) => onExport("servicio", v)} />
        </div>
        <Field label="Texto de introducción" testid="export-intro" textarea value={ec.intro} onChange={(v) => onExport("intro", v)} />
        <Field label="Texto de empresa" testid="export-empresa" textarea value={ec.empresa_texto} onChange={(v) => onExport("empresa_texto", v)} />
      </div>

      <div className="bg-white border border-slate-200 rounded-lg p-5">
        <div className="flex items-center justify-between mb-4">
          <div>
          <h3 className="font-display font-bold text-slate-900 text-sm uppercase tracking-wide">Consideraciones comerciales</h3>
          <p className="text-xs text-slate-500 mt-0.5" data-testid="clauses-scope-note">Los cambios aquí solo afectan a esta cotización.</p>
          </div>
          <button data-testid="add-clause" onClick={addClause}
            className="flex items-center gap-1.5 text-sm text-emerald-600 hover:text-emerald-700 font-medium">
            <Plus className="h-4 w-4" /> Agregar cláusula
          </button>
        </div>
        <div className="space-y-2">
          {consideraciones.map((c, i) => (
            <div key={i} className="flex gap-2 items-start" data-testid={`clause-${i}`}>
              <span className="font-mono text-xs text-slate-400 w-5 pt-2.5">{letters[i] || i + 1}.</span>
              <textarea data-testid={`clause-input-${i}`} rows={2} value={c} onChange={(e) => setClause(i, e.target.value)}
                className="flex-1 px-3 py-2 rounded-md border border-slate-200 focus:outline-none focus:ring-2 focus:ring-emerald-500 text-sm resize-y" />
              <button data-testid={`clause-del-${i}`} onClick={() => removeClause(i)} className="text-slate-300 hover:text-red-500 pt-2.5">
                <Trash2 className="h-4 w-4" />
              </button>
            </div>
          ))}
        </div>
        <div className="mt-4 max-w-xs">
          <Field label="Validez de la propuesta" testid="export-validez" value={ec.validez} onChange={(v) => onExport("validez", v)} />
        </div>
      </div>
    </div>
  );
}
